var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Resizable } from "react-resizable";
const ResizableColumn = (props) => {
    const { onResize, width } = props, restProps = __rest(props, ["onResize", "width"]);
    if (!width) {
        return React.createElement("th", Object.assign({}, restProps));
    }
    return (React.createElement(Resizable, { width: width, height: 0, handle: React.createElement("span", { className: "react-resizable-handle", onClick: (e) => {
                e.stopPropagation();
            } }), onResize: onResize, draggableOpts: { enableUserSelectHack: false } },
        React.createElement("th", Object.assign({}, restProps))));
};
export default ResizableColumn;
